angular
  .module('LessonControllers')

  .service('lesson', [
    '$mdDialog',
    'api',
    'EXAM',
    function($mdDialog, api, EXAM) {
      this.dialogDetail = function(id, ev) {
        $mdDialog.show({
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          preserveScope: true,
          locals: {
            lessonId: id
          },
          templateUrl: '/ng1/www/modules/lesson/html/dialog_lesson.html',
          controller: [
            '$scope',
            '$mdDialog',
            'lessonId',
            'api',
            '$location',
            function($scope, $mdDialog, lessonId, api, $location) {
              console.log('🔥', api.me);
              $scope.level = api?.data?.me?.profile?.level;

              $scope.exam = EXAM;

              $scope.role = api.data.me
                ? api.data.me.roles[api.data.me.current_role]
                : undefined;

              api.sync(
                api.getLesson,
                function(data) {
                  $scope.lesson = data;
                },
                lessonId
              );

              $scope.hide = function(url) {
                $location.url(url);
                $mdDialog.hide();
              };
            }
          ]
        });
      };

      this.dialogList = function(ev) {
        $mdDialog.show({
          targetEvent: ev,
          clickOutsideToClose: true,
          preserveScope: true,
          parent: angular.element(document.body),
          templateUrl: '/ng1/www/modules/lesson/html/dialog_lessons.html',

          controller: [
            'scope',
            '$mdDialog',
            function(scope, $mdDialog) {
              api.sync(api.getLessons, function(data) {
                scope.lessons = data;
              });

              scope.hide = function() {
                $mdDialog.hide();
              };
            }
          ]
        });
      };

      this.getPercentage = function(score) {
        var x = score;
        return 5 * x + 50;
      };
    }
  ]);
